import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { defineStore } from 'pinia'

import type {
  BusinessFeatures,
  TemporaryBusinessFeatures,
} from '../../../api/seller/types'

export type BusinessFeaturesKeys = keyof BusinessFeatures
export type TemporaryBusinessFeaturesKeys = keyof TemporaryBusinessFeatures

interface State {
  businessFeatures: BusinessFeatures | null
}

export const useBusinessFeaturesStore = defineStore('businessFeatures', {
  actions: {
    async fetchBusinessFeatures() {
      const $httpFetch = useHttpFetch()
      this.businessFeatures = await $httpFetch(
        '/api/seller-experience/seller/features',
      )
    },
    /**
     * @example
     * const { isFeatureEnabled } = useBusinessFeaturesStore()
     * isFeatureEnabled('supportEnabled') // false | true
     */
    isFeatureEnabled(
      feature?: BusinessFeaturesKeys | TemporaryBusinessFeaturesKeys,
    ): boolean {
      const isTemporaryFeatureEnabled =
        this.businessFeatures?.temporary?.[
          feature as TemporaryBusinessFeaturesKeys
        ]
      const isPermanentFeatureEnabled =
        this.businessFeatures?.[feature as BusinessFeaturesKeys]

      return Boolean(
        feature && (isTemporaryFeatureEnabled || isPermanentFeatureEnabled),
      )
    },
  },
  getters: {
    hasFetchBusinessFeature: (state) => Boolean(state.businessFeatures),
  },
  state: (): State => ({
    businessFeatures: null,
  }),
})
